import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
} from "reactstrap";

import {
  getRolesAdmin,
  addUserByRole,
  downloadAllBrokersReport,
} from "../../slices/admin/thunk";
import { useDispatch } from "react-redux";
import Loading from "../../Components/Loading";
import BrokersTable from "../../Components/Tables/BrokerTable/BrokersTable";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import Swal from "sweetalert2";
import { DASHBOARD_USER_ROLES } from "../../constants";
import { capitalizeFirstLetter } from "../../utils/utils";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable.js";
import brokerIcon from "../../assets/images/iconsRoles/brokerIcon.svg";
import { DocumentTitle } from "../../Components/Common/DocumentTitle";

const DashboardAdminBrokers = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [modalAddBroker, setModalAddBroker] = useState(false);

  const dispatch = useDispatch();

  const [brokers, setBrokers] = useState([]);
  const [totalBrokers, setTotalBrokers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const handleToggleModal = () => {
    setModalAddBroker(!modalAddBroker);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchRolesAdmin = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesAdmin({ role: "brokers", page: currentPage, query: searchTerm })
      ).unwrap();
      setBrokers(response.data);
      setTotalBrokers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchRolesAdmin();
  }, [currentPage, debouncedSearchTerm, dispatch]);

  // useEffect(() => {
  //   fetchRolesAdmin();
  // }, [currentPage, debouncedSearchTerm, dispatch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleCreateBroker = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        addUserByRole({ role: DASHBOARD_USER_ROLES.BROKER, data: values })
      ).unwrap();
      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Broker created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setModalAddBroker(false);
        fetchRolesAdmin();
      } else {
        Swal.fire({
          title: "Error!",
          text:
            response.error.message ||
            "An error occurred while adding the broker",
          icon: "error",
          confirmButtonText: "OK",
        });
        setModalAddBroker(true);
        setLoadingCreate(false);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred while adding the broker",
        icon: "error",
        confirmButtonText: "OK",
      });
      setModalAddBroker(true);
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };


  return (
    <React.Fragment>
      {/* <Modal */}
      <AddRoleModal
        open={modalAddBroker}
        setOpen={setModalAddBroker}
        roleToAdd={DASHBOARD_USER_ROLES.BROKER}
        onCreate={handleCreateBroker}
        loading={loadingCreate}
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role="Brokers" icon={brokerIcon} svg={true} />
          <Card className="mb-4 pb-3 shadow-none">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />
                  <DropdownActionsTable
                    downloadMethod={downloadAllBrokersReport}
                  />
                </div>

                <ButtonAddRole open={handleToggleModal} roleToAdd="Broker" />
              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <BrokersTable
                        data={brokers}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          currentPage,
                          totalPages,
                          totalItems: totalBrokers,
                          pageSize,
                          onChangePage: handleChangePage,
                        }}
                        searchDone={searchDone}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardAdminBrokers;
